import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject, startWith, distinctUntilChanged, debounceTime, map } from 'rxjs';
import { ChargeMasterApiService } from 'src/app/services/domain_code/charge-master-api.service';
import { MyApprovalsService } from '../../master-data/my-approvals-list/my-approvals.service';

@Component({
    selector: 'logzy-ops-date-change-list',
    templateUrl: './ops-date-change-list.component.html',
    styleUrls: ['./ops-date-change-list.component.scss']
})
export class OpsDateChangeListComponent implements OnInit {
    constructor(private _snackBar: MatSnackBar,
        private _chargemasterservice: ChargeMasterApiService,
        private route: ActivatedRoute,
        private router: Router, private myApprovalsService: MyApprovalsService) { }
    displayColumns = ['request_number', 'booking_type', 'requested_by', 'request_date', 'status', 'ops_request_type', 'action']
    requestList: MatTableDataSource<any>;
    pageLength = 0;
    pageSize = 10;
    pageIndex = 0;
    update: boolean = false;
    loading: boolean = true;
    approvalList: MatTableDataSource<any>;
    searchText = new BehaviorSubject<string>('');
    loggedInUser: any;
    ngOnInit(): void {
        this.getApprovalListByFilters();
        this.searchText.pipe(
            startWith(''),
            distinctUntilChanged(),
            debounceTime(1000),
            map((searchText) => {
                this.getApprovalListByFilters(this.pageSize, this.pageIndex, searchText);
            })
        ).subscribe();
    }

    view(data: any) {
        this.router.navigateByUrl(`/master-data/approval-details?id=${data.booking?.request}&approval_id=${data.id}&type=${data.booking?.transaction_type}&rtype=${data.booking.request_type.dev_name}`);

    }

    back() {
        this.router.navigateByUrl(`ops-date-change`);
    }

    getApprovalListByFilters(pageSize = null, pageIndex = null, searchTerm = '', ordering = '') {
        this.loggedInUser = JSON.parse(localStorage.getItem('current_user'));
        pageSize = pageSize || this.pageSize;
        pageIndex = pageIndex || this.pageIndex;
        this.myApprovalsService.getAllApprovals(pageSize, pageIndex + 1, searchTerm, ordering).subscribe({
            next: response => {
                this.approvalList = new MatTableDataSource(response.results.filter(item => item.requested_by?.id === this.loggedInUser?.id));
                console.log( this.approvalList," this.approvalList")
                this.pageLength = this.approvalList.data.length;
                this.loading = false;
                this.update = false;
            }
        })
    }

    pageChanged(event: PageEvent) {
        this.update = true;
        this.pageSize = event.pageSize;
        this.pageIndex = event.pageIndex;
        this.getApprovalListByFilters(this.pageSize, this.pageIndex);
    }

    navigateToNewRequest() {
        this.router.navigateByUrl(`/ops-date-change/view`)
    }
    applyFilter(event) {
        this.update = true;
        this.pageIndex = 0;
        this.searchText.next(event);
    }

    getNatureOfRequest(request: any) {
        switch (request.booking.request_type.dev_name) {
            case 'lease':
                if (request.booking.transaction_type == 'use')
                    return 'Lease | Use';
                else
                    return 'Lease | Supply';
            case 'one_way':
                if (request.booking.transaction_type == 'use')
                    return 'One Way | Use';
                else
                    return 'One Way | Supply';
            case 'buy_sell':
                if (request.booking.transaction_type == 'use')
                    return 'Trade | Buy';
                else
                    return 'Trade | Sell';
            case 'empty_repo':
                if (request.booking.transaction_type == 'use')
                    return 'Empty Repo | Use';
                else
                    return '';
        }
        return '-';
    }
    
    getBackgroundColor(status: string) {
        switch (status) {
            case 'Pending':
                return '#1661d9';
            case 'Approved':
                return '#005d00';
        }
    }
}
